class SnackbarUtils {
  #snackBar = {
    enqueueSnackbar: () => "",
    closeSnackbar: () => "",
  };

  setSnackBar(enqueueSnackbar, closeSnackbar) {
    this.#snackBar.enqueueSnackbar = enqueueSnackbar;
    this.#snackBar.closeSnackbar = closeSnackbar;
  }

  success(msg, options = {}) {
    return this.toast(msg, { ...options, variant: 'success' });
  }
  warning(msg, options = {}) {
    return this.toast(msg, { ...options, variant: 'warning' });
  }
  info(msg, options = {}) {
    return this.toast(msg, { ...options, variant: 'info' });
  }

  error(msg, options = {}) {
    return this.toast(msg, { ...options, variant: 'error' });
  }
  toast(msg, options = {}) {
    const finalOptions = {
      variant: 'default',
      ...options,
    };
    return this.#snackBar.enqueueSnackbar(msg, { ...finalOptions });
  }
  enqueueSnackbar(prop = {}) {
    return this.#snackBar.enqueueSnackbar(prop.message, prop.options);
  }
  closeSnackbar(key) {
    this.#snackBar.closeSnackbar(key);
  }
}

const snackbarUtilsInstance = new SnackbarUtils();
export default snackbarUtilsInstance;